import React from 'react';
import { LinkList, LinkListItem } from '../Components/LinkList';
import { localize } from '../Util/L10n';

export const Teaser = ({
  imageUrl,
  showOverlayHandler,
  downloads,
  studyplans,
}) => (
  <div className="teaser">
    <div className="teaser__left">
      <img className="w-100" src={imageUrl} />
    </div>
    <div className="teaser__right">
      <h4 className="teaser__title">{localize('title')}</h4>
      <LinkList>
        {Object.keys(downloads).map((name) => (
          <LinkListItem
            key={name}
            href={'/' + downloads[name]}
            type="file"
            target="_blank"
            rel="noopener"
          >
            {name}
          </LinkListItem>
        ))}

        {studyplans.map((studyplan) => {
          return (
            <LinkListItem
              key={studyplan.uid}
              type="overlay"
              onClick={showOverlayHandler}
              href={`#/studyplan/${studyplan.uid}/start`}
            >
              {studyplan.name}
            </LinkListItem>
          );
        })}
      </LinkList>
    </div>
  </div>
);
